var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVoices = function SvgIconVoices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 12.5V1.635q0-.484.334-.81.335-.324.832-.325h10.668q.498 0 .832.325t.334.81v7.568q0 .485-.334.81a1.15 1.15 0 0 1-.832.325H2.722zM2.917 4.949v.761zm1.944-1.523v3.806zM7 1.904v6.851zm2.139 1.522v3.806zm1.944 1.523v.761z"
  })));
};
export default SvgIconVoices;